import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-angular-grids";
import { Observable } from "rxjs";
import { Subject } from "rxjs";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { map } from "rxjs/operators";
@Injectable({
  providedIn: "root",
})
export class ClientAuthorizationReportService extends Subject<DataStateChangeEventArgs> {
  constructor(
    private http: HttpClient,
    public global: GlobalComponent,
    public general: GeneralService
  ) {
    super();
  }
  public outputValuesAuthorizationReport(
    state
  ): void {
    this.getClientAuthorizationReportInfo(state).subscribe((x) =>
      super.next(x)
    );
  }
  getClientAuthorizationReportInfo(
    state?
  ): Observable<DataStateChangeEventArgs> {
    let url;
    console.log(state.isHousing)
    if (state.isHousing) {
      url = "api/ClientAuthorization/GetServiceTypeClientAuthorizationDetails";
    } else {
      url = "api/ClientAuthorization/getClientAuthorizationDetails";
    }
    return this.http
      .post<any>(url, state)
      .pipe(
        map(
          (response: any) =>
            <any>{
              result: response["result"],
              count: response["count"],
            }
        )
      )
      .pipe(
        map((e: any) => {
          e.result.forEach((element) => {
            element.phone1 =
              element.phone1 != null && element.phone1 != ""
                ? this.general.reconverPhoneGoogleLibhttpsave(element.phone1)
                : null;
            element.address =
              (element.street != null ? element.street : "") +
              " " +
              (element.apt != null ? element.apt : "") +
              " " +
              (element.city != null ? element.city : "") +
              " " +
              (element.state != null ? element.state : "") +
              " " +
              (element.zipCode != null ? element.zipCode : "");
          });
          return e;
        })
      );
  }
}
